import { render, staticRenderFns } from "./FlagCh.vue?vue&type=template&id=24fbfd42&"
import script from "./FlagCh.vue?vue&type=script&lang=js&"
export * from "./FlagCh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports